import layoutHeaderAside from '@/layout/header-aside'

const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 用户路由
export default [
  {
    path: '/operate',
    name: 'Operate',
    meta: {
      title: '运营',
      auth: true
    },
    redirect: { name: 'OperateFeedback' },
    component: layoutHeaderAside,
    children: [
      // {
      //   path: 'feedback',
      //   name: 'OperateFeedback',
      //   meta: {
      //     title: '意见反馈',
      //     auth: true
      //   },
      //   component: _import('operate/feedback')
      // },
      {
        path: 'bind',
        name: 'MemberBind',
        meta: {
          title: '绑定申请',
          auth: true
        },
        component: _import('operate/member-bind')
      },
      {
        path: 'bindLog',
        name: 'MemberBindLog',
        meta: {
          title: '绑定日志',
          auth: true
        },
        component: _import('operate/bind-log')
      },
      {
        path: 'message',
        name: 'OperateMessage',
        meta: {
          title: '消息管理',
          auth: true
        },
        component: _import('operate/message')
      },
      {
        path: 'comment',
        name: 'OperateComment',
        meta: {
          title: '评论管理',
          auth: true
        },
        component: _import('operate/comment')
      }

    ]
  }
]
